// Reads a JSON blob injected into the page (via a <script type="application/json"> element) and parses it; returns {} on failure.
const parseInjectedJson = (elementId) => {
  const element = document.getElementById(elementId);
  if (!element) return {};
  try {
    return JSON.parse(element.textContent) || {};
  } catch (parseError) {
    console.warn(`Failed to parse JSON from #${elementId}:`, parseError);
    return {};
  }
};

// Returns the real Shopify product handle for a collection name; falls back to a slugified guess if no mapping exists.
const resolveProductHandle = (collectionName, handlesByTitle) =>
  handlesByTitle[collectionName] || toHandle(collectionName);

// Returns a new array where badged collections (New, Best Seller, etc.) come first; original order kept within each group.
const sortCollectionsByBadge = (collections, tagsData) =>
  collections.slice().sort((collectionA, collectionB) => {
    const isTaggedA = tagsData[collectionA.handle] ? 1 : 0;
    const isTaggedB = tagsData[collectionB.handle] ? 1 : 0;
    return isTaggedB - isTaggedA;
  });

// Decides how many cards to render and whether to show the "view all" button.
// 5–7 → show 4 to avoid a partial second row; exactly 8 fills the grid so no button is needed.
const getDisplayConfig = (total) => {
  if (total <= 4) return { maxDisplay: total, showButton: false };
  if (total <= 7) return { maxDisplay: 4, showButton: true };
  if (total === 8) return { maxDisplay: 8, showButton: false };
  return { maxDisplay: 8, showButton: true };
};

// Builds the URL for the "view all" button on the artist's collections page.
const buildViewAllHref = (artistId) =>
  `/pages/artist-all-collections?id=${encodeURIComponent(artistId)}`;

// Builds the badge element (New, Best Seller, etc.); null when no tag.
const buildBadgeElement = (shopifyTag) => {
  if (!shopifyTag) return null;
  const badge = document.createElement("span");
  badge.className = "artist-collection-card__badge";
  badge.style.backgroundColor = shopifyTag.color;
  badge.textContent = shopifyTag.name;
  return badge;
};

// Builds a single collection card element (link + optional badge + image + name).
const buildCardElement = (collection, tagsData) => {
  const card = document.createElement("a");
  card.className = "artist-collection-card";
  card.href = `/products/${collection.handle}`;

  const badge = buildBadgeElement(tagsData[collection.handle]);
  if (badge) card.appendChild(badge);

  const imageWrap = document.createElement("div");
  imageWrap.className = "artist-collection-card__image-wrap";
  const image = document.createElement("img");
  image.className = "artist-collection-card__image";
  image.src = getScaledCloudinaryUrl(collection.coverUrl || "", 500, "f_auto");
  image.alt = collection.name || "";
  image.loading = "lazy";
  imageWrap.appendChild(image);
  card.appendChild(imageWrap);

  const text = document.createElement("div");
  text.className = "artist-collection-card__text";
  const name = document.createElement("div");
  name.className = "artist-collection-card__name";
  name.textContent = collection.name || "";
  text.appendChild(name);
  card.appendChild(text);

  return card;
};

// Renders the artist's collections grid: sorts by badge, picks how many to display, and writes the markup into the DOM.
function renderCollections(collections, artistId) {
  const grid = document.getElementById("collections-grid");
  const section = document.getElementById("section-collections");
  const viewAllLink = document.getElementById("collections-view-all");

  if (!grid || !section || !viewAllLink) return;

  if (!collections || collections.length === 0) {
    section.style.display = "none";
    return;
  }
  section.style.display = "";

  const collectionTagsData = parseInjectedJson("collection-tags-data");
  const collectionHandlesByTitle = parseInjectedJson("collection-handles-data");

  const enrichedCollections = collections.map((collection) => ({
    ...collection,
    handle: resolveProductHandle(collection.name, collectionHandlesByTitle),
  }));

  const sortedCollections = sortCollectionsByBadge(
    enrichedCollections,
    collectionTagsData,
  );

  const { maxDisplay, showButton } = getDisplayConfig(sortedCollections.length);
  const displayCollections = sortedCollections.slice(0, maxDisplay);

  viewAllLink.style.display = showButton ? "" : "none";
  if (showButton && artistId) {
    viewAllLink.href = buildViewAllHref(artistId);
  }

  grid.classList.toggle(
    "artist-collections__grid--multi",
    displayCollections.length >= 4,
  );

  grid.replaceChildren(
    ...displayCollections.map((collection) =>
      buildCardElement(collection, collectionTagsData),
    ),
  );
}
